import React from "react";
import Icon from "components/AppIcon";

const ViewControls = ({
  viewMode,
  onViewModeChange,
  resultCount,
  isLoading,
}) => {
  return (
    <div className="flex items-center justify-between mb-6 p-4 bg-surface border border-border rounded-lg">
      <div className="flex items-center space-x-4">
        <div className="text-sm text-text-secondary">
          {isLoading ? (
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
              <span>Loading products...</span>
            </div>
          ) : (
            <span>
              <span className="font-medium text-text-primary">
                {resultCount}
              </span>{" "}
              products found
            </span>
          )}
        </div>
      </div>

      <div className="flex items-center space-x-4">
        <div className="flex items-center border border-border rounded-md overflow-hidden">
          <button
            onClick={() => onViewModeChange("grid")}
            disabled={isLoading}
            className={`p-2 transition-smooth disabled:opacity-50 ${
              viewMode === "grid"
                ? "bg-primary text-white"
                : "bg-surface text-text-secondary hover:text-text-primary hover:bg-secondary-50"
            }`}
            aria-label="Grid view"
          >
            <Icon name="Grid3X3" size={16} />
          </button>
          <button
            onClick={() => onViewModeChange("list")}
            disabled={isLoading}
            className={`p-2 transition-smooth disabled:opacity-50 ${
              viewMode === "list"
                ? "bg-primary text-white"
                : "bg-surface text-text-secondary hover:text-text-primary hover:bg-secondary-50"
            }`}
            aria-label="List view"
          >
            <Icon name="List" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewControls;
